var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F6F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 18.6665C28.3807 18.6665 29.5 17.5472 29.5 16.1665C29.5 14.7858 28.3807 13.6665 27 13.6665C25.6193 13.6665 24.5 14.7858 24.5 16.1665C24.5 17.5472 25.6193 18.6665 27 18.6665Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.5C18.3807 24.5 19.5 23.3807 19.5 22C19.5 20.6193 18.3807 19.5 17 19.5C15.6193 19.5 14.5 20.6193 14.5 22C14.5 23.3807 15.6193 24.5 17 24.5Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.3335C28.3807 30.3335 29.5 29.2142 29.5 27.8335C29.5 26.4528 28.3807 25.3335 27 25.3335C25.6193 25.3335 24.5 26.4528 24.5 27.8335C24.5 29.2142 25.6193 30.3335 27 30.3335Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1583 23.2583L24.85 26.575",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8417 17.4248L19.1583 20.7415",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare3);
export default __webpack_public_path__ + "static/media/share3.a0b2d2be0065083bf1f9cc5bfdfed8c4.svg";
export { ForwardRef as ReactComponent };